/**
 * router.tsx — ประกอบ route ทั้งหมดของเว็บ
 */

import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '~/features/shell/AppShell';
import { LoginPage } from '~/features/auth/LoginPage';
import { AdminRoute, ProtectedRoute } from '~/features/auth/ProtectedRoute';
import { CustomersPage } from '~/features/customers/CustomersPage';
import { SuppliersPage } from '~/features/suppliers/SuppliersPage';
import { ProductsPage } from '~/features/products/ProductsPage';
import { QuotationsListPage } from '~/features/quotations/QuotationsListPage';
import { QuotationFormPage } from '~/features/quotations/QuotationFormPage';
import { QuotationDetailPage } from '~/features/quotations/QuotationDetailPage';
import { TaxInvoicesListPage } from '~/features/tax-invoices/TaxInvoicesListPage';
import { TaxInvoiceFormPage } from '~/features/tax-invoices/TaxInvoiceFormPage';
import { TaxInvoiceDetailPage } from '~/features/tax-invoices/TaxInvoiceDetailPage';
import { ExpensesPage } from '~/features/expenses/ExpensesPage';
import { DashboardPage } from '~/features/reports/DashboardPage';
import { VatReportPage } from '~/features/reports/VatReportPage';
import { SettingsPage } from '~/features/settings/SettingsPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'quotations', element: <QuotationsListPage /> },
      { path: 'quotations/new', element: <QuotationFormPage /> },
      { path: 'quotations/:id', element: <QuotationDetailPage /> },
      { path: 'quotations/:id/edit', element: <QuotationFormPage /> },
      { path: 'tax-invoices', element: <TaxInvoicesListPage /> },
      { path: 'tax-invoices/new', element: <TaxInvoiceFormPage /> },
      { path: 'tax-invoices/:id', element: <TaxInvoiceDetailPage /> },
      { path: 'tax-invoices/:id/edit', element: <TaxInvoiceFormPage /> },
      { path: 'expenses', element: <ExpensesPage /> },
      { path: 'reports/vat', element: <VatReportPage /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'suppliers', element: <SuppliersPage /> },
      { path: 'products', element: <ProductsPage /> },
      {
        path: 'settings',
        element: (
          <AdminRoute>
            <SettingsPage />
          </AdminRoute>
        ),
      },
    ],
  },
]);
